<template>
  <NuxtLink :to="courseUrl"
            class="course-card">
    <div class="card-image">
      <UIDebug badge>LESSONS: {{ course.lessonsStudied || 0 }}</UIDebug>
      <img
        :src="course.imageUrl || '/assets/images/course-category/default.jpg'"
        :alt="course.title"
        width="360"
        height="240"
        loading="lazy"
        decoding="async"
      >

    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Course } from '@/domain/entities/course.entity'
import { useIndexRoutes } from '@/composables/locale/useIndexRoutes'

const { buildPath, DEFAULT_CATEGORY } = useIndexRoutes()
const props = defineProps<{
  course: Course
}>()

const courseUrl = computed(() =>
  buildPath({
    category: props.course.category || DEFAULT_CATEGORY,
    slug: props.course.slug,
  }),
)
</script>

<style scoped>
.course-card {
  display: block;
  position: relative;
  border-radius: 9px;
  overflow: hidden;
  text-decoration: none;
  aspect-ratio: 280 / 411;
}

.card-image {
  position: absolute;
  inset: 0;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
}

@media (hover: hover) and (pointer: fine) {
  .course-card:hover .card-image img {
    transform: scale(1.07);
  }
}
</style>
